import styled from "styled-components";
import { BodySmall, BodySmallMedium, VerySmall } from "../../../../../components/typography/styled";


type ActiveProp = {
  active?:boolean;
}

export const Container = styled.div<ActiveProp>`
  display: flex;
  width:100%;
  min-width: 0;
  max-width: 100%;
  padding:20px;
  box-sizing: border-box;
  flex-direction: column;
  gap:10px;
  border-radius:8px;
  border: ${({theme, active}) => active ? '': `1px solid ${theme.palette[20]}`};
  background: ${({theme, active}) => active ? theme.isDark ? theme.palette[200] : theme.primary[40] : theme.palette[10]};
  /* box-shadow:${({theme, active}) => active ?  theme.isDark ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)' : `0px 0px 0px 3px #E0EAFF` : ''}; */
`

export const TitleWrapper = styled.div`
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    gap: 4px 10px;
  }

  > :first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const HeadCardContainer = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  gap:14px;
  width: 100%;
  min-width: 0;

  > img {
    flex-shrink: 0;
  }
`

export const Datetext = styled(BodySmall)`
  color:${({theme}) => theme.palette[600]};
  flex-shrink: 0;
`
export const Attachments = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: auto;
  min-width: 0;
  margin: 0 -20px -20px;
  border-top:${({theme}) => `1px solid ${theme.palette[20]}`};
  padding:20px;
  gap:10px;

  @media screen and (max-width: 768px) {
    margin: 0 -14px -14px;
    padding: 14px;
  }
`

export const AttachmentsWrapper = styled.div`
  display:flex;
  flex-direction: row;
  gap:10px;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

export const AttachmentContainer = styled.div`
  width: 363px;
  min-width: 0;
  max-width: 100%;
  /* height: 129px; */
  /* overflow: hidden; */
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding:10px;
  gap:10px;
  justify-content: space-between;
  border:${({theme}) => `1px solid ${theme.palette[20]}`};
  border-radius:4px;
  background-color: ${({theme}) => theme.palette[10]};
  flex: 0 1 363px;

  @media screen and (max-width: 768px) {
    width: 100%;
    flex-basis: auto;
  }

  > svg {
    flex-shrink: 0;
  }

  &:hover{
    cursor: pointer;
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};

  }
`

type AttachmentImgProps = {
  $placeholder?: boolean;
}

export const AttachmentImg = styled.img<AttachmentImgProps>`
  object-fit: ${({$placeholder}) => $placeholder ? 'contain' : 'cover'};
  padding: ${({$placeholder}) => $placeholder ? '3px' : '0'};
  box-sizing: border-box;
  width:28px;
  min-width: 28px;
  flex-shrink: 0;
  margin-right:8px;
  border-radius: 4px;
  height:28px;
  border:${({theme}) => `1px solid ${theme.palette[20]}`};
`

export const AttachmentTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  flex: 1;
  /* padding:10px; */
`

export const AttachmentTitleRow = styled.div`
  flex-direction: column;
  max-width:100%;
  min-width: 0;
  flex: 1;
  display: flex;
  /* align-items: center; */
  /* gap:8px; */
`

export const AttachmentName = styled(BodySmallMedium)`
  color:${({theme}) => theme.primary[600]};
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`

export const AttachmentSize = styled(VerySmall)`
  color:${({theme}) => theme.palette[600]};
`

export const DivMessage = styled.div`
  color:${({theme}) => theme.base.black};
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;

  img,
  video,
  iframe {
    max-width: 100%;
    height: auto;
  }

  pre {
    max-width: 100%;
    overflow-x: auto;
  }
  a{
    color:${({theme}) => theme.isDark ? theme.primary[400] : theme.primary[600]};
    font-weight: 500;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  a:hover{
    color:${({theme}) => theme.isDark ? theme.primary[300] : theme.primary[700]};
  }
  &>p{
    overflow-wrap: anywhere;
    word-break: break-word;
  }

`
